"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryButtonList = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _api = require("../../api");
var _CategoryButtonItem = require("../CategoryButtonItem/CategoryButtonItem");
var _Loading = require("../Loading/Loading");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CategoryButtonList = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { data, loading } = (0, _api.useCategories)();
    if (loading) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.Loading, {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId('category-links-wrapper'),
        children: data === null || data === void 0 ? void 0 : data.collection.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_CategoryButtonItem.CategoryButtonItem, {
                ...item
            }, item.name))
    });
};
exports.CategoryButtonList = CategoryButtonList;
